import './index.scss'

let goods_card = document.querySelector('.goods__cart')

if (!goods_card) {
    document.querySelector('.sort').remove()
    document.querySelector('.filter__btn-show').remove()
    document.querySelector('.filter').remove()
}